export default defineNuxtPlugin(() => {
  const router = useRouter()
  const getRouteBaseName = useRouteBaseName()

  window.addEventListener('scroll', () => {
    const routeName = String(getRouteBaseName(router.currentRoute.value) ?? '')
    if (routeName in listDetailPairs) {
      listScrollPositions.set(routeName, { left: window.scrollX, top: window.scrollY })
    }
  }, { passive: true })
})
